module.exports = __webpack_public_path__ + "img/Visa_Brandmark_Blue_RGB_2021.b39b39d5.png";